module.exports = __webpack_public_path__ + "img/bri.696b759e.svg";